import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HistoryItemPeriod } from '../../interfaces/historyItem';


@Injectable()
export class monitorPeriodsService {
    public selectedPeriods: Subject<selectedPeriods> = new Subject<selectedPeriods>();
}


export interface selectedPeriods
{
    s1:HistoryItemPeriod;
    s2:HistoryItemPeriod;
    s3:HistoryItemPeriod;
  //  BS:HistoryItemPeriod;
  //  VL:HistoryItemPeriod;
}